import axios from '@/plugins/axios'

function store(data) {
  return axios.post('/yacht-models', data)
    .then(response => response.data)
}
function update(data, id) {
  return axios.patch(`/yacht-models/${id}`, data)
    .then(response => response.data)
}

export default {
  save(data, id) {
    return id ? update(data, id) : store(data)
  },
  fetch(params) {
    return axios.get('/yacht-models', { params: params })
      .then(response => response.data)
  },
  fetchPerCountry(params) {
    return axios.get('/yacht-models/per-country', { params: params })
      .then(response => response.data)
  },
  find(id) {
    return axios.get(`/yacht-models/${id}`)
      .then(response => response.data)
  },
  destroy(id) {
    return axios.delete(`/yacht-models/${id}`)
  },
  fetchEquipmentPacks(id, params) {
    return axios.get(`/yacht-models/${id}/equipment-packs`, { params: params })
      .then(response => response.data)
  },
  fetchSpecs() {
    return axios.get('/yacht-models/specs')
      .then(response => response.data)
  },
  updateCountryPivots(data) {
    return axios.post('/yacht-models/country', data)
      .then(response => response.data)
  },
  updateBookingPricelist(data) {
    return axios.post('/yacht-models/booking-pricelist', data)
      .then(response => response.data)
  },
  associateEquipmentPacks(id, data) {
    return axios.post(`/yacht-models/${id}/associate-equipment-packs`, data)
      .then(response => response.data)
  },
  syncFromSheets() {
    return axios.get('/yacht-models/sheets-sync').then(response => response.data)
  }
}
